module.exports = __webpack_public_path__ + "img/8c54843.png";